<template>
  <div class="object-list table-responsive" v-if="isFlowAvailable">
    <!-- <vuestic-widget :headerText="$t(title)" v-if="isFlowAvailable"> -->
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-3 col-sm-8 form-group">
            <button class="btn btn-primary btn-sm" @click="buttonAction('')">
              Add
            </button>
          </div>
          <div class="col-md-3 offset-6 col-sm-8 form-group with-icon-left">
            <div class="input-group">
              <input id="input-icon-left" name="input-icon-left" @keyup="filteredObject()" v-model="search" required/>
              <i class="glyphicon glyphicon-search icon-left input-icon search-icon"></i>
              <label class="control-label" for="input-icon-left">Search</label><i class="bar"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="row">
          <table class="table table-striped first-td-padding">
            <thead>
              <tr>
                <th v-for="field in tableFields" @click="sortBy(field.name)"
                  :class="{ active: sortKey == field.name }" class="hover-text">
                  {{ field.title }}
                  <span class="arrow" :class="sortOrders[field.name] > 0 ? 'asc' : 'dsc'">
                  </span>
                </th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="rows" v-for="data in displayData">
                <td v-for="field in tableFields"><span class="link" @click="buttonAction(data.id)">{{ data[field.name] }}</span></td>
                <td><toggle-button @change="change(data.id)" :value="!data.disabled" :sync="true" color="#009AB1" :labels="{checked: 'Enabled', unchecked: 'Disabled'}" :width="72" /></td>
              </tr>
              <tr v-if="!rows">
                <td :colspan="tableFields.length + 1" style="text-align: center;">Nothing to show here</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col  d-flex justify-content-center"" v-if="filteredData.length > 10">
          <div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
            <div class="btn-group" role="group" aria-label="First group">
              <button type="button" class="btn btn-primary" @click="onFirstPage()" :class="[isCurrentPage(1) ? 'disabled' : '']">
                <i class="ion-ios-arrow-back arrow-back"></i><i class="ion-ios-arrow-back arrow-back"></i>
              </button>
              <button type="button" class="btn btn-primary" @click="onPreviousPage()" :class="[isCurrentPage(1) ? 'disabled' : '']">
                <i class="ion-ios-arrow-back arrow-back"></i>
              </button>
              <button type="button" class="btn btn-primary" v-for="n in range(pageStart, pageEnd)" @click="onChangePage(n)" :class="[isCurrentPage(n) ? 'focus' : '']">{{ n }}</button>
              <button type="button" class="btn btn-primary" @click="onNextPage()" :class="[isCurrentPage(pages) ? 'disabled' : '']">
                <i class="ion-ios-arrow-forward arrow-forward"></i>
              </button>
              <button type="button" class="btn btn-primary" @click="onLastPage()" :class="[isCurrentPage(pages) ? 'disabled' : '']">
                <i class="ion-ios-arrow-forward arrow-forward"></i><i class="ion-ios-arrow-forward arrow-forward"></i>
              </button>
            </div>
          </div>
          <div>
            <input type="text" v-bind:value="perPage" v-on:input="perPageChange" class="pagination-input" /> Per page
          </div>
        </div>
      </div>
    <!-- </vuestic-widget>
    <vuestic-widget :headerText="$t(title)" v-else>
      <div class="col  d-flex justify-content-center"">
        <h1>Stories not found for this Account.</h1>
      </div>
    </vuestic-widget> -->
  </div>
</template>

<script>
  import axios from 'axios'
  import store from '../../../store'
  import listDefinition from './list-definition'

  export default {
    name: 'automation-tab',
    mounted: function () {
      this.getObjects()
    },
    computed: {
      startNo () {
        return (this.pageNo - 1) * this.perPage
      },
      endNo () {
        return this.pageNo * this.perPage
      },
      displayData () {
        return this.filteredData.slice(this.startNo, this.endNo)
      },
      pages () {
        return Math.ceil(this.filteredData.length / this.perPage)
      },
      pageStart () {
        if (this.$mq === 'mobile') {
          return this.pageNo
        } else if (this.$mq === 'tablet') {
          if (this.pageNo === 1 || this.pageNo <= 2 || this.pages <= 3) {
            return 1
          } else if (this.pageNo >= (this.pages - 1)) {
            return this.pages - 2
          }
          return this.pageNo - 1
        } else {
          if (this.pageNo === 1 || this.pageNo <= 2 || this.pages <= 5) {
            return 1
          } else if (this.pageNo >= (this.pages - 2)) {
            return this.pages - 4
          }
          return this.pageNo - 2
        }
      },
      pageEnd () {
        if (this.$mq === 'mobile') {
          return this.pageStart
        } else if (this.$mq === 'tablet') {
          return this.pageStart + 2 > this.pages ? this.pages : this.pageStart + 2
        } else {
          return this.pageStart + 4 > this.pages ? this.pages : this.pageStart + 4
        }
      },
      rows () {
        return this.displayData.length > 0
      },
      isFlowAvailable () {
        return localStorage.getItem('flow-token') || false
      }
    },
    data: function () {
      var sortOrders = {}
      var tableFields = listDefinition.tableFields
      tableFields.forEach(function (field) {
        sortOrders[field.key] = 1
      })
      return {
        sortKey: '',
        sortOrders: sortOrders,
        data: [],
        search: '',
        filteredData: [],
        pageNo: 1,
        perPage: 25,
        object: {},
        listDefinition,
        tableFields,
        list_urls: listDefinition.urls,
        title: listDefinition.title,
        revision: ''
      }
    },
    methods: {
      getObjects: function () {
        store.commit('setLoading', true)
        var self = this
        const url = `https://${localStorage.getItem('fonestorm-account')}.${process.env.Flow_URL}${self.list_urls.getObjects}`
        axios.get(url, {
          dataType: 'json',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('flow-token'),
            'Node-RED-API-Version': 'v2'
          },
          mode: 'no-cors',
          credentials: 'include'
        })
        .then(async function (response) {
          self.object = response.data
          self.revision = response.data.rev
          self.data = []
          await response.data[self.listDefinition.name].map((data) => {
            if (data.type === 'tab') {
              self.data.push(data)
            }
          })
          self.filteredData = self.data
          if (self.sortKey) {
            self.sortBy(self.sortKey)
          }
          store.commit('setLoading', false)
        })
        .catch(function (error) {
          console.log(error)
          store.commit('setLoading', false)
          if (localStorage.getItem('flow-token') && error.response.status === 401) {
            self.$router.push({ name: 'Logout' })
          }
        })
      },
      sortBy: function (key) {
        this.sortKey = key
        this.sortOrders[key] = this.sortOrders[key] * -1
        var sortKey = this.sortKey
        var order = this.sortOrders[sortKey] || 1
        var data = this.filteredData
        if (sortKey) {
          data = data.sort(function (a, b) {
            a = a[sortKey]
            b = b[sortKey]
            return (a === b ? 0 : a > b ? 1 : -1) * order
          })
        }
        this.filteredData = data
      },
      filteredObject: function () {
        var self = this
        if (self.search) {
          self.filteredData = self.data.filter(self.filterList)
        } else {
          self.filteredData = self.data
        }
      },
      filterList (object) {
        var self = this
        var result = false
        self.tableFields.forEach((field) => {
          if (object[field.name].toLowerCase().indexOf(self.search.toLowerCase()) > -1) {
            result = true
          }
        })
        return result
      },
      onChangePage (n) {
        this.pageNo = n
      },
      isCurrentPage (n) {
        return this.pageNo === n
      },
      onNextPage () {
        this.pageNo = this.pageNo < this.pages ? this.pageNo + 1 : this.pageNo
      },
      onPreviousPage () {
        this.pageNo = this.pageNo > 1 ? this.pageNo - 1 : this.pageNo
      },
      onFirstPage () {
        this.pageNo = 1
      },
      onLastPage () {
        this.pageNo = this.pages
      },
      range: function (min, max) {
        var array = []
        var j = 0
        for (var i = min; i <= max; i++) {
          array[j] = i
          j++
        }
        return array
      },
      change (id) {
        var self = this
        self.object[self.listDefinition.name].forEach((flow) => {
          if (flow.id && flow.id === id) {
            self.filteredData.forEach((data) => {
              if (data.id === id) {
                flow.disabled = !data.disabled
              }
            })
          }
        })

        store.commit('setLoading', true)
        const url = `https://${localStorage.getItem('fonestorm-account')}.${process.env.Flow_URL}${self.list_urls.getObjects}`
        axios.post(url, self.object, {
          dataType: 'json',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('flow-token'),
            'Node-RED-API-Version': 'v2'
          },
          mode: 'no-cors',
          credentials: 'include'
        })
        .then(async function (response) {
          store.commit('setLoading', false)
          self.getObjects()
        })
        .catch(function (error) {
          console.log(error)
          store.commit('setLoading', false)
          if (localStorage.getItem('flow-token') && error.response.status === 401) {
            self.$router.push({ name: 'Logout' })
          }
          self.getObjects()
        })
      },
      buttonAction: async function (page) {
        var self = this
        if (page === '') {
          const unique = `${Math.random().toString(36).substr(2, 9)}.${Math.random().toString(36).substr(2, 6)}`
          window.open(`https://${localStorage.getItem('fonestorm-account')}.${process.env.Flow_URL}?access_token=${localStorage.getItem('flow-login-token')}&redirect=#flow/${unique}`, '_blank')
          self.object.flows.push({
            type: 'tab',
            id: unique,
            label: 'New Story'
          })
          const url = `https://${localStorage.getItem('fonestorm-account')}.${process.env.Flow_URL}${self.list_urls.getObjects}`
          try {
            await axios.post(url,
              self.object,
              {
                dataType: 'json',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                  'Authorization': localStorage.getItem('flow-token'),
                  'Node-RED-API-Version': 'v2'
                },
                mode: 'no-cors',
                credentials: 'include'
              })
            store.commit('setLoading', false)
            self.getObjects()
          } catch (error) {
            console.log(error)
            store.commit('setLoading', false)
            if (localStorage.getItem('flow-token') && error.response.status === 401) {
              self.$router.push({ name: 'Logout' })
            }
            self.getObjects()
          }
        } else {
          window.open(`https://${localStorage.getItem('fonestorm-account')}.${process.env.Flow_URL}?access_token=${localStorage.getItem('flow-login-token')}&redirect=#flow/${page}`, '_blank')
        }
      },
      perPageChange (event) {
        var self = this
        if (event.target.value !== '') {
          self.perPage = parseInt(event.target.value)
        }
      }
    }
  }
</script>
<style lang="scss">
  @import "../../../sass/variables";

  th.active {
  color: $fractel-teal;
  }

  th.active .arrow {
  opacity: 1;
  }

  .arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0;
  }

  .arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid #000;
  }

  .arrow.dsc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid #000;
  }

  .search-input {
    border: 1px solid black;
    border-radius: 5px;
  }

  .link {
    color: $fractel-teal;
    &:hover {
      text-decoration: underline;
      cursor: pointer;
    }
  }

  .hover-text:hover {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/automation-tab/Automation.vue